// Module
var code = "<div class=\"sampleimg {{optional}}\"> {{id}} <span>{{barcode}}</span> </div>";
// Exports
export default code;